import { useCallback, useEffect, useState } from 'react';
import { fetchVarausList } from '@/services/varausService';

export const useDayReservationList = (day) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!day) {
      setList([]);
      return;
    }

    const ids = day.reservations?.filter(Boolean);
    if (!ids || ids.length === 0) {
      setList([]);
      return;
    }

    let ignore = false;
    setLoading(true);
    setError(null);

    try {
      const res = await fetchVarausList(ids);
      if (!ignore) setList(res || []);
    }
    catch (e) {
      if (!ignore) setError(e);
    }
    finally {
      if (!ignore) setLoading(false);
    }
  }, [day]);

  useEffect(() => {
    if (!day) {
      setList([]);
      return;
    }

    const ids = day.reservations?.filter(Boolean);
    if (!ids || ids.length === 0) {
      setList([]);
      return;
    }

    let ignore = false;

    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchVarausList(ids);
        if (!ignore) setList(res || []);
      }
      catch (e) {
        if (!ignore) setError(e);
      }
      finally {
        if (!ignore) setLoading(false);
      }
    })();

    return () => {
      ignore = true;
    };
  }, [day]);

  return { list, loading, error, refetch };
};
